import dashboard from './dashboard';
import activity from './activity';
import profile from './profile';

// ===========================|| MENU ITEMS ||=========================== //

const menuItems = {
    items: [dashboard, activity]
};

export default menuItems;
